// Generated by `npm run content:build`. Do not edit manually.
import type { VisualDefinition } from '../assets';
import type { UnitSpriteDefinition } from '../sprite-atlas';

export const EXTENSION_VISUALS = {
  "unit.giant-skeleton.death-bomb": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/giant-skeleton.png",
    "visualScale": 1.2,
    "anchor": [
      0.5,
      0.5
    ],
    "healthBarOffsetY": 0,
    "projectile": {
      "shape": "bomb",
      "radius": 17,
      "fillColor": 2434341,
      "strokeColor": 9211020,
      "trailColor": 16742144,
      "impactColor": 16742144,
      "impactStrokeColor": 16773301,
      "impactRadius": 72,
      "impact": {
        "durationSeconds": 0.65,
        "radius": 72,
        "coreColor": 16773301,
        "fireColor": 16742144,
        "hotColor": 16762178,
        "shockwaveColor": 16773301,
        "smokeColor": 4144959,
        "flameCount": 9,
        "sparkCount": 14
      }
    }
  },
  "unit.giant-skeleton": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/giant-skeleton.png",
    "visualScale": 1.46,
    "anchor": [
      0.5,
      0.87
    ],
    "healthBarOffsetY": -82,
    "shadow": {
      "width": 50,
      "height": 17,
      "y": 6,
      "skew": 24
    }
  },
  "spell.goblin-barrel": {
    "fallbackColor": 16777215,
    "texture": "/assets/projectiles/goblin-barrel.png",
    "visualScale": 1,
    "anchor": [
      0.5,
      0.5
    ],
    "healthBarOffsetY": 0,
    "projectile": {
      "texture": "/assets/projectiles/goblin-barrel.png",
      "width": 54,
      "radius": 14,
      "fillColor": 7294247,
      "strokeColor": 15119167,
      "trailColor": 9474192,
      "impactColor": 12886446,
      "impactStrokeColor": 16773301,
      "impactRadius": 34,
      "flightOffsetY": -24,
      "animation": {
        "pulseHz": 3,
        "pulseAmount": 0.04
      },
      "targetHit": {
        "durationSeconds": 0.16,
        "color": 12886446,
        "hotColor": 16773301
      }
    }
  },
  "unit.goblin": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/goblin-gang.png",
    "visualScale": 1.32,
    "anchor": [
      0.5,
      0.86
    ],
    "healthBarOffsetY": -62,
    "shadow": {
      "width": 26,
      "height": 9,
      "y": 5,
      "skew": 30
    }
  },
  "unit.mega-knight.deploy": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/mega-knight.png",
    "visualScale": 1.2,
    "anchor": [
      0.5,
      0.5
    ],
    "healthBarOffsetY": 0,
    "projectile": {
      "shape": "bomb",
      "radius": 18,
      "fillColor": 4543822,
      "strokeColor": 11317373,
      "trailColor": 2960685,
      "impactColor": 12624742,
      "impactStrokeColor": 16771763,
      "impactRadius": 58
    }
  },
  "unit.mega-knight.leap": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/mega-knight.png",
    "visualScale": 1.2,
    "anchor": [
      0.5,
      0.5
    ],
    "healthBarOffsetY": 0,
    "projectile": {
      "shape": "bomb",
      "radius": 18,
      "fillColor": 4543822,
      "strokeColor": 11317373,
      "trailColor": 2960685,
      "impactColor": 14064296,
      "impactStrokeColor": 16771763,
      "impactRadius": 52
    }
  },
  "unit.mega-knight": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/mega-knight.png",
    "visualScale": 1.48,
    "anchor": [
      0.5,
      0.87
    ],
    "healthBarOffsetY": -82,
    "shadow": {
      "width": 54,
      "height": 18,
      "y": 6,
      "skew": 24
    }
  },
  "unit.spear-goblin": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/goblin-gang.png",
    "visualScale": 1.28,
    "anchor": [
      0.5,
      0.86
    ],
    "healthBarOffsetY": -64,
    "shadow": {
      "width": 25,
      "height": 9,
      "y": 5,
      "skew": 30
    },
    "attackCue": {
      "durationSeconds": 0.13,
      "radius": 6,
      "offsetY": -38,
      "forward": 16,
      "side": 0,
      "color": 15122137,
      "hotColor": 16777215
    },
    "projectile": {
      "shape": "arrow",
      "radius": 3,
      "fillColor": 14097862,
      "strokeColor": 16777215,
      "trailColor": 8097560,
      "impactColor": 14097862,
      "impactStrokeColor": 16777215,
      "impactRadius": 12,
      "flightOffsetY": -38,
      "launchOffset": {
        "forward": 16,
        "side": 0,
        "settleSeconds": 0.1
      },
      "targetHit": {
        "durationSeconds": 0.14,
        "color": 14097862,
        "hotColor": 16777215
      }
    }
  },
  "spell.the-log": {
    "fallbackColor": 16777215,
    "texture": "/assets/projectiles/the-log.png",
    "visualScale": 1,
    "anchor": [
      0.5,
      0.5
    ],
    "healthBarOffsetY": 0,
    "projectile": {
      "texture": "/assets/projectiles/the-log.png",
      "width": 68,
      "radius": 17,
      "fillColor": 8344626,
      "strokeColor": 15119167,
      "trailColor": 6177073,
      "impactColor": 10385183,
      "impactStrokeColor": 16773301,
      "impactRadius": 32,
      "targetHit": {
        "durationSeconds": 0.16,
        "color": 10385183,
        "hotColor": 16773301
      }
    }
  },
  "unit.witch": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/witch.png",
    "visualScale": 1.34,
    "anchor": [
      0.5,
      0.87
    ],
    "healthBarOffsetY": -72,
    "shadow": {
      "width": 36,
      "height": 13,
      "y": 4,
      "skew": 28
    },
    "attackCue": {
      "durationSeconds": 0.2,
      "radius": 11,
      "offsetY": -45,
      "forward": 16,
      "side": 0,
      "color": 11162879,
      "hotColor": 15912191
    },
    "projectile": {
      "shape": "orb",
      "radius": 10,
      "fillColor": 11162879,
      "strokeColor": 15912191,
      "trailColor": 6497535,
      "impactColor": 11162879,
      "impactStrokeColor": 15912191,
      "impactRadius": 28,
      "flightOffsetY": -45,
      "launchOffset": {
        "forward": 16,
        "side": 0,
        "settleSeconds": 0.12
      },
      "animation": {
        "pulseHz": 7,
        "pulseAmount": 0.09
      },
      "targetHit": {
        "durationSeconds": 0.2,
        "color": 11162879,
        "hotColor": 15912191
      }
    }
  },
  "unit.wizard": {
    "fallbackColor": 16777215,
    "texture": "/assets/cards/wizard.png",
    "visualScale": 1.3,
    "anchor": [
      0.5,
      0.86
    ],
    "healthBarOffsetY": -70,
    "shadow": {
      "width": 36,
      "height": 14,
      "y": 4,
      "skew": 35
    },
    "projectile": {
      "shape": "fire",
      "texture": "/assets/projectiles/wizard-firebolt.png",
      "width": 62,
      "radius": 11,
      "fillColor": 16741417,
      "strokeColor": 16770170,
      "trailColor": 16734752,
      "impactColor": 16742949,
      "impactStrokeColor": 16773552,
      "impactRadius": 34,
      "flightOffsetY": -46,
      "launchOffset": {
        "forward": 18,
        "side": 0,
        "settleSeconds": 0.12
      },
      "animation": {
        "pulseHz": 9,
        "pulseAmount": 0.08
      },
      "trail": {
        "color": 16734752,
        "coreColor": 16762178,
        "emberColor": 16773307,
        "radius": 9,
        "lifetimeSeconds": 0.28,
        "emitIntervalSeconds": 0.025,
        "drift": 12
      },
      "impact": {
        "durationSeconds": 0.48,
        "radius": 42,
        "coreColor": 16775856,
        "fireColor": 16734752,
        "hotColor": 16765538,
        "shockwaveColor": 16773552,
        "smokeColor": 6509634,
        "flameCount": 7,
        "sparkCount": 10
      },
      "targetHit": {
        "durationSeconds": 0.22,
        "color": 16742949,
        "hotColor": 16775856
      }
    },
    "attackCue": {
      "durationSeconds": 0.22,
      "radius": 13,
      "offsetY": -43,
      "forward": 18,
      "side": 0,
      "color": 16742949,
      "hotColor": 16775856
    }
  }
} as unknown as Readonly<Record<string, VisualDefinition>>;
export const EXTENSION_CARD_IMAGES = {
  "giant-skeleton": "/assets/cards/giant-skeleton.png",
  "goblin-barrel": "/assets/cards/goblin-barrel.png",
  "goblin-gang": "/assets/cards/goblin-gang.png",
  "mega-knight": "/assets/cards/mega-knight.png",
  "minion-horde": "/assets/cards/minion-horde.png",
  "the-log": "/assets/cards/the-log.png",
  "witch": "/assets/cards/witch.png",
  "wizard": "/assets/cards/wizard.png"
} as Readonly<Record<string, string>>;
export const EXTENSION_ARENA_ASSETS = {} as Readonly<Record<string, string>>;
export const EXTENSION_UNIT_SPRITES = {
  "unit.giant-skeleton": {
    "asset": "giant-skeleton",
    "player": "giant_skeleton",
    "bot": "giant_skeleton_enemy",
    "family": "units"
  },
  "unit.goblin": {
    "asset": "goblin",
    "player": "goblin1",
    "bot": "goblin1_enemy",
    "family": "units"
  },
  "unit.mega-knight": {
    "asset": "mega-knight",
    "player": "mega_knight",
    "bot": "mega_knight_red",
    "family": "units"
  },
  "unit.spear-goblin": {
    "asset": "spear-goblin",
    "player": "goblinArcher_blue",
    "bot": "goblinArcher",
    "family": "units"
  },
  "unit.witch": {
    "asset": "witch",
    "player": "witch1",
    "bot": "witch1_enemy",
    "family": "units"
  },
  "unit.wizard": {
    "asset": "wizard",
    "player": "wizard1",
    "bot": "wizard1_red",
    "family": "units",
    "mirrorX": true
  }
} as Readonly<Record<string, UnitSpriteDefinition>>;
